// extracted by mini-css-extract-plugin
module.exports = {"audioHitLayer":"AudioHitLayer_audioHitLayer__3DV52","hitProxy":"AudioHitLayer_hitProxy__2lD9T"};